import React, {useRef, useState, useEffect, useContext} from 'react'
import UserContext from '../context/UserContext'
import {Button, Col} from 'react-bootstrap'
import {BsCameraFill, BsExclamationCircle} from 'react-icons/bs'
import InventoryImage from './InventoryImage'
import ImagePreview from './ImagePreview'
import ConfirmDialog from './ConfirmDialog'
import './InventoryImages.css'
import styles from './InventoryForm.module.css'
import ImageViewPanel from './ImageViewPanel'
import exifr from 'exifr' 
import OldImages from './OldImages'


function InventoryImages(props) {

    const userCtx = useContext(UserContext)
    const baseURL = process.env.REACT_APP_MODE === "TEST" ? process.env.REACT_APP_API_URL_TEST : process.env.REACT_APP_API_URL_PROD
    const deleteImageURL = (imageId) => `${baseURL}inventory_images/${imageId}`
    const [confirmDialogParams, setConfirmDialogParams] = useState({show:false})

    const uploadFileRef = useRef()
    const [files, setFiles] = useState([])
    const [existingImages, setExistingImages] = useState([])
    const [toAddImages, setToAddImages] = useState([])
    const [selectedImages, setSelectedImages] = useState([])

    const [deleteEnabled, setDeleteEnabled] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    // const [confirmDialogParams, setConfirmDialogParams] = useState({})

    const [showImagePanel, setShowImagePanel] = useState(false)

    const AcceptableImageAgeInDays = process.env.REACT_APP_ACCEPTABLE_IMAGE_AGE_DAYS

    const [imagesTooOld, setImagesTooOld] = useState([])



    // builds and returns array of rows, each row is 4 elements long (except the last one that can be shorter)
    const buildArrayOfRows = (originalArray) => {
        const splitSize = 4

        // console.log("Building Array of Rows - orignal array", originalArray)

        let newArray = []
        // original Array is either array of image objects (for existing inventory with images) or just a list of file names (for new inventory)
        // sort only if existing inventory
        let oldArray = []
        if (originalArray.length > 0 && !!originalArray[0].created_at) {
            oldArray = originalArray.sort((a,b) => new Date(a.created_at) > new Date(b.created_at) ? 1 : -1 )
        } else {
            // array of file names - do not sort
            oldArray = [...originalArray]
        }
        

        for (let i = 0; i < oldArray.length; i += splitSize) {
            newArray.push(oldArray.slice(i, i + splitSize));
        }
        return newArray
    }



    const onImageSelect = (image) => {
        // console.log("Image selected", image)
        // add or remove image from array
        let newImageList = selectedImages
        if (newImageList.indexOf(image) == -1) {
            // add element
            newImageList.push(image);
        } else {
            // remove element
            const index = selectedImages.indexOf(image)
            if (index >= 0) {
                newImageList.splice(index, 1)
            }
        }
        setSelectedImages([...newImageList])
    }



    // const newImageFileAdded = (anImageFile) => {
    //     props.addNewImages(anImageFile)

    // }

    // const handleFileEvent = (e) => {
    //     const chosenFiles = Array.prototype.slice.call(e.target.files);
    //     setFiles(chosenFiles)
    // }


    // return array of Rows without removed elements
    const removeElementFromArrayOfRows = (array, element) => {
        let newArray = []
        // array of rows is array of array, so we have to search in each internal array
        array.forEach(row => {
            row.forEach(el => {
                if (el !== element) {
                    newArray.push(el)
                }
            })
        })
        
        // build and return new array of rows
        return buildArrayOfRows(newArray)
    }



    const deleteImage = async (image) => {
        try {            
            let httpMethod = "DELETE"
            const url=deleteImageURL(image.id)
                   
            const response = await fetch(url, {
                method: httpMethod,
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                }
            })

            if (response.status === 200) {
                const responseData = await response.json()
                // console.log("image deleted", responseData)

                // remove image from image array

            } else {
                console.log("Failed to delete image", response)
                setConfirmDialogParams({
                    show: true,
                    text: ['Failed to delete an image', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            }
        } catch (e) {
            console.log("Failed to delete image", e)
            setConfirmDialogParams({
                show: true,
                text: ['Unexpected error occurred while trying to delete an image', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        }

    
    }



    // remove selected images from the list of files or mark as to be deleted (if already an image in Inventory)
    // or toggle delete - if the image already marked to be deleted - unmark
    // if image is one to add - remove it toAddImages array
    const handleRemove =() => {
        const files_to_remove = []
        const images_to_toggle = []
        let tempToAddImages = [...toAddImages]
        let cancelImageUpload = false
        selectedImages.forEach(img => {
            if (!!img.id) {
                // image already belongs to the inventory - mark it to delete
                images_to_toggle.push(img)
            } else {
                // file name for the image to add - remove
                files_to_remove.push(img)
                // at least one image shouldn't be uploaded
                cancelImageUpload = true
                tempToAddImages = tempToAddImages.filter(addimg => addimg !== img)
            }
        })

        if (images_to_toggle.length > 0) {
            props.toggleDelete(images_to_toggle)
        }

        if (files_to_remove.length > 0) {
            props.onRemoveImageFiles(files_to_remove)
        }

        if (cancelImageUpload) {
            setToAddImages([...tempToAddImages])
        }
        
        setSelectedImages([])
    }


    const confirmedDelete = (result) => {
        setShowConfirmDelete(false)
        if (result === 'confirm') {
            doDelete()
        }
    }



    // const handleDelete = () => {
        

    //     const deleteItemClick = () => {
    //         let plural = ''
    //         if (selectedImages.length > 1) {
    //             plural = 's'
    //         }
    //         setConfirmDialogParams({
    //             text: [
    //                 `Are you sure you want to delete selected image${plural}?`, 
    //                 `If you proceed the image${plural} will be deleted permanently.`
    //             ],
    //             textClass: styles['confirmation-text'],
    //             prompt_class: styles['alert-prompt-black'],
    //             cancel_button_text: 'Cancel',
    //             confirm_button_text: 'Delete',
    //             confirm_button_variant: 'danger',
    //             onClose: (result) => confirmedDelete(result),
    //         })
    //         setShowConfirmDelete(true)
    //     }


    //     // delete button will act differently depending on what is selected
    //     // for new inventory the button shows "Remove" rather than "Delete" because the images not saved yet
    //     if (!!props.inventoryItem?.id) {
    //         deleteItemClick()
    //     } else {
    //         props.onRemoveImageFiles(selectedImages)
    //     }

        


    // }


    const doDelete = () => {
        if (selectedImages.length > 0) {
            // let newImgArray = existingImages
            // selectedImages.forEach(img => {
            //     deleteImage(img)
            //     // newImgArray = removeElementFromArrayOfRows(newImgArray, img)
            //     newImgArray = removeElementFromArrayOfRows(newImgArray, img)
            // })
            let existingImgArray = [...existingImages]
            selectedImages.forEach(img => {
                deleteImage(img)
                // existingIngArray.forEach(exist_img => {
                //     if (exist_img !== img) {
                //         newImgArray.push(exist_img)
                //     }
                // })
                existingImgArray = existingImgArray.filter(el => el !== img)
            })
            setExistingImages([...existingImgArray])


            // setExistingImages([...newImgArray])
            // remove deleted images from image array
            setSelectedImages([])
            // signal to parent component that visit media changed - it will force to realod
            // props.onInventoryChanged()
        }
    }



    

    const getInventoryImages = async (inventory_id) => {
        const url = `${baseURL}inventory_images/invntry/${inventory_id}`
        await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`
            }
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("inventory images", data)
            if (!!data) {
                // setImages(data)
            }
        })
        .catch(e => {
            console.log("error getting images", e)
            setConfirmDialogParams({
                show: true,
                text: ['Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                prompt: 'Unexpected error occurred while trying to get item images',
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })
    }


    const checkImageDate = async (file) => {
        // let { dateTimeOriginal, dateTaken} = await exifr.parse(file, {exif: [ 'Date Time Original','Date Taken']})
        // console.log("Check Image Date - file", file)
        const exif = await exifr.parse(file)
        if (!!exif?.DateTimeOriginal) {
            // console.log("DateTimeOriginal", exif.DateTimeOriginal)
            return exif.DateTimeOriginal
        } else if (!!exif?.DateTaken) {
            // console.log("DateTaken", exif.DateTaken)
            return exif.DateTaken
        } else if (!!exif?.DateCreated) {
            // console.log("DateCreated", exif.DateCreated)
            return exif.DateCreated
        } else if (!!exif?.DateModified) {
            // console.log("DateModified", exif.DateModified)
            return exif.DateModified
        // } else if (!!exif) {
        //     console.log("exif", exif)
        } else {
            // console.log("file last modified date", file.lastModified)
            return file.lastModified
        }
        

        // await exifr.parse(file, {exif: ['Date Time Original','Date Taken', 'CreateDate' ]})
        //     .then(exif => console.log("exif", exif))
        // console.log("dateTimeOriginal, dateTaken", dateTimeOriginal, dateTaken)
        

    }

    const onImagesSelectedForUpload = (e) => {
        // if existing inventory (id is not null) - call upload function in the parent
        // if (!!props.inventoryItem.id) {
        //     props.onAddImages(e)
        // } else {
            // new inventory item - show previews
            // console.log("Files chosen for upload - e.target.files", e.target.files)

        if (e.target.files.length > 0) {
            // check image dates. Images should be recent

            const images_to_add = []
            const images_too_old = []
            let promises = []
            Array.from(e.target.files).forEach(file => {

                const dt = checkImageDate(file)
                promises.push(dt)
            //     console.log("image date returned", dt)
            //     const img_date = Date.parse(checkImageDate(file))
            //     console.log("new Date() - img_date", new Date(), img_date, new Date() - img_date)
            //     console.log("Image age", (new Date() - img_date) / (1000*60*60*24))
            //     if (Math.floor((new Date() - img_date) / (1000*60*60*24)) > AcceptableImageAgeInDays) {
            //         // image is older than 3 days
            //         images_too_old.push(files)
            //     } else {
            //         images_to_add.push(file)
            //     }
            })
            Promise.allSettled(promises)
                .then(results => {
                    let promise_index = 0
                    results.forEach(result => { 
                        if(result.status === 'fulfilled') {
                            // console.log("image date returned", result.value)
                            // only allow images taking this year
                            const img_date = new Date(result.value)
                            // console.log("img_date", img_date)
                            const img_year = img_date.getFullYear()
                            // console.log("img_year", img_year)
                            
                            const today = new Date()
                            // console.log("today.getFullYear()", today.getFullYear())
                            if (img_year !== today.getFullYear()) {
                                images_too_old.push(e.target.files[promise_index])
                            } else {
                                images_to_add.push(e.target.files[promise_index])
                            }
                            // if (Math.floor((new Date() - img_date) / (1000*60*60*24)) > AcceptableImageAgeInDays) {
                            //             // image is older than 3 days
                            //             images_too_old.push(e.target.files[promise_index])
                            // } else {
                            //     images_to_add.push(e.target.files[promise_index])
                            // }
                        } else {
                            console.log('Rejected:', result.reason);
                        }
                        promise_index++
                    })
                    setImagesTooOld(images_too_old)
                    props.onAddNewImageFiles(images_to_add)
                    // console.log("Images too old", images_too_old)
                })

            // props.onAddNewImageFiles(images_to_add)

            // if (images_too_old.length > 0) {
            //     setImagesTooOld(images_too_old)
            // }

            // props.onAddNewImageFiles(Array.from(e.target.files))
        }
            // const chosenFiles = Array.prototype.slice.call(e.target.files);
            // console.log("Files chosen for upload", chosenFiles)
            // if (!!chosenFiles && chosenFiles.length > 0) {
            //     // setExistingImages(buildArrayOfRows(chosenFiles))
            //     // chosenFiles.forEach(f => {

            //     //     checkImageDate(f)
            //     // })
            //     // setExistingImages(chosenFiles)
            //     props.onAddNewImageFiles(chosenFiles)
            // } 
        // }
        
    }


    // show selected images in Image View Panel
    const viewBig = () => {
        if (selectedImages.length > 0) {
            setShowImagePanel(true)
        }
    }



    useEffect(() => {
        // console.log("Inventory Images props", props)
        if (!!props.inventoryItem?.id /*&& props.inventoryItem?.images?.length > 0*/) {
            getInventoryImages(props.inventoryItem.id)
        }
        


    }, [props.inventoryItem])



    useEffect(() => {
        // console.log("Existing images", props.images)
        // console.log("To add images", props.image_files)
        // if (props.images.length > 0) {

            
            // setExistingImages(buildArrayOfRows(props.images))
            setExistingImages(props.images)
        // }
        // if (props.image_files.length > 0) {
            // setToAddImages(buildArrayOfRows(props.image_files))
            // setToAddImages([...props.image_files])
        // }
    }, [props.images/*, props.image_files*/])


    useEffect(() => {
        if (selectedImages.length > 0) {
            // enable delete button
            setDeleteEnabled(true)
        } else {
            // disable delete button
            setDeleteEnabled(false)
        }

    }, [selectedImages.length])

    return (
        <>
            <div className={`inventory-images ${existingImages.length + toAddImages.length > 0 ? 'inventory-images-with-images':''}`}>
                <div className='d-flex justify-content-between inventory-images-toolbar'>
                    <div className='inline-block text-left'>
                        <BsCameraFill className='inventory-images-icon' />
                            Images
                    </div>
                    {existingImages.filter(img => !!img.markToDelete).length + props.image_files.length > 0 &&
                        <div className='inline-block text-left text-danger'>
                            <span className='fw-bold'>Please click Save Changes button to commit  to adding/removing images</span>
                        </div>
                    }

                    <div className="inline-block text-right">

                        <Button 
                            className="mx-2 btn-sm" 
                            variant="outline-primary" 
                            // onClick={handleDelete} 
                            onClick={viewBig} 
                            disabled={!deleteEnabled}
                        >
                            View Images
                        </Button>


                        <input
                            id="mediaUpload"
                            type="file"
                            multiple
                            className="d-none"
                            ref={uploadFileRef}
                            accept='image/jpg, image/png, image/jpeg'
                            onChange={onImagesSelectedForUpload}
                            // disabled={fileLimit}
                        />

                        <label htmlFor="mediaUpload">
                            <a className={`btn btn-outline-primary btn-sm mx-2` }>
                            Add Images
                            </a>
                        </label>

                        <Button 
                            className="mx-2 btn-sm" 
                            variant="outline-danger" 
                            // onClick={handleDelete} 
                            onClick={handleRemove} 
                            disabled={!deleteEnabled}
                        >
                            Remove selected/Toggle delete
                        </Button>

                    </div>
                </div>

                

                {props.image_files.length > 0 && 
                    <div className='container-fluid row p-1 m-3 gx-1 to_add_images' >
                        { props.image_files.map((img, img_ix) => {
                                return (
                                    <Col key={img_ix} xxl={2} xl={2} lg={2} md={3} sm={4} xs={12} className={` ${styles.handle_overflow} `}>
                                        <ImagePreview 
                                            mode='preview'
                                            image={img} 
                                            onImageSelect={(img) => onImageSelect(img) }
                                            isImageSelected={selectedImages.indexOf(img) >= 0}
                                            overlayText='WILL ADD'
                                            overlayTextClassName='add-overlay'
                                            // onImageAdded={newImageFileAdded}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </div>
                }

                {existingImages.length > 0 && 
                    
                    <div className={`container-fluid row p-1 m-3 gx-1 existing_images`} >
                        {existingImages.map((img, img_ix) => {
                            return (
                                <Col key={img_ix} xxl={2} xl={2} lg={2} md={3} sm={4} xs={12} className={`mb-3 ${styles.handle_overflow} `}>
                                    <InventoryImage 
                                        mode='thumb'
                                        image={img} 
                                        key={img_ix}
                                        onImageSelect={(img) => onImageSelect(img) }
                                        isImageSelected={selectedImages.indexOf(img) >= 0}
                                    />
                                </Col>
                            )})
                        }
                    </div>
                }
            </div> 

            {showImagePanel &&
                <ImageViewPanel show={showImagePanel} onHide={() => {setShowImagePanel(false)}} images={selectedImages}/>
            }

            {imagesTooOld.length > 0 &&
                < OldImages
                    images={imagesTooOld} 
                    onClose={() => setImagesTooOld([])} 
                    cancel_button_text='OK'
                    title="These images are too old and won't be uploaded. Please upload current year images."
                />
            }
            
            {confirmDialogParams.show &&
                <ConfirmDialog 
                    show={confirmDialogParams.show}
                    iconColor='red'
                    iconSize='2rem'
                    icon={confirmDialogParams.icon}
                    title={confirmDialogParams.title}
                    title_class={confirmDialogParams.title_class}
                    text={confirmDialogParams.text}
                    textClass={confirmDialogParams.textClass}
                    prompt={confirmDialogParams.prompt}
                    prompt_class={confirmDialogParams.prompt_class}
                    cancel_button_text={confirmDialogParams.cancel_button_text}
                    confirm_button_text={confirmDialogParams.confirm_button_text}
                    confirm_button_variant={confirmDialogParams.confirm_button_variant}
                    onClose={confirmDialogParams.onClose}
                    confirm_only={true}
                />
            }
            
        </>
    )
}

export default InventoryImages
